export default "__VITE_ASSET__16fa7ff5__"